import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import Gravatar from '../../../common/Gravatar';
import TimestampTooltip from '../../../common/TimestampTooltip';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            alignItems: 'center'
        },
        timelineAvatar: {
            marginTop: 0
        },
        timestamp: {
            marginLeft: 8
        }
    })
);

interface Props {
    event: any;
    className?: string;
}

function BasicTimelineEvent(props: Props) {
    const classes = useStyles({});
    const { event, className } = props;

    return (
        <ListItem key={event.id} alignItems="flex-start" className={classNames(classes.root, className)}>
            <ListItemAvatar className={classes.timelineAvatar}>
                <Gravatar email={event.email} />
            </ListItemAvatar>
            <ListItemText
                primary={
                    <React.Fragment>
                        {event.title}
                        <TimestampTooltip timestamp={event.timestamp}>
                            <Typography
                                className={classes.timestamp}
                                component="span"
                                display="inline"
                                color="textSecondary"
                            >
                                - {moment(event.timestamp).fromNow()}
                            </Typography>
                        </TimestampTooltip>
                    </React.Fragment>
                }
            />
        </ListItem>
    );
};

export default BasicTimelineEvent;
